/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HTTPValidationError, LegalDiagnosisRequest, LegalDiagnosisResponse } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class LegalDiagnosis<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Realiza un diagnóstico jurídico especializado según el ordenamiento jurídico colombiano, incluyendo análisis constitucional, legal y jurisprudencial.
   *
   * @tags diagnosis
   * @name DiagnoseEndpointLegalDiagnosisAnalyzePost
   * @summary Diagnóstico Jurídico Especializado
   * @request POST:/legal-diagnosis/analyze
   */
  diagnoseEndpointLegalDiagnosisAnalyzePost = (data: LegalDiagnosisRequest, params: RequestParams = {}) =>
    this.request<LegalDiagnosisResponse, HTTPValidationError>({
      path: `/legal-diagnosis/analyze`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Obtiene las áreas del derecho disponibles para diagnóstico
   *
   * @tags diagnosis
   * @name GetLegalAreasLegalDiagnosisAreasGet
   * @summary Áreas del Derecho
   * @request GET:/legal-diagnosis/areas
   */
  getLegalAreasLegalDiagnosisAreasGet = (params: RequestParams = {}) =>
    this.request<Record<string, string[]>, any>({
      path: `/legal-diagnosis/areas`,
      method: "GET",
      format: "json",
      ...params,
    });
}
